// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { GridElementSubType } from "../app/_models/grid-element-subtype";

export const environment = {
  production: false,
  CONFIG_URL: "./assets/config.json",
  API_BASE_URL: "/icg/v1/rest/",
  MQTT_CONFIG: {
    clean: false
  },
  EXCLUDED_NODES: [
    GridElementSubType.Consumer
    // GridElementSubType.SubstationBusbar,
  ],

  // API_BASE_URL: "/icg/v1/rest/",
  // MQTT_CONFIG: {
  //   clientId: 'gui',
  //   clean: false,
  //   host: 'localhost',
  //   port: 9102,
  //   username: 'gui',
  //   password: 'dev'
  // },
  // TOPOLOGY: {
  //   topologyId: 'tme-lab',
  //   mapCenterLat: 57.013273686254,
  //   mapCenterLon: 8.7285798823692,
  //   zoomLevel: 18
  // },
  // EXCLUDED_NODES: [
  //   GridElementSubType.Consumer,
  //   GridElementSubType.SubstationBusbar
  // ]
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
